import { useEffect } from 'react'
import { logError } from '@/features/shared/utils/logger'
import { datadogRum } from '@datadog/browser-rum'
import { useExperimentsContext } from '@/features/shared/context/ExperimentsContext'

export const useSyncExperimentsWithGlobalVariable = () => {
  const { data: variations, status } = useExperimentsContext()

  useEffect(() => {
    if (status === 'success' && variations) {
      try {
        Object.entries(variations).forEach(([key, value]) => {
          if (value.value) {
            datadogRum.addFeatureFlagEvaluation(`exp_${key}`, value.value)
          }
        })
      } catch (e) {
        // dont wanna accidentally bring down the app
        logError(new Error('Unable to set experiment global variables', { cause: e }))
      }
    }
  }, [status, variations])
}
